// EN
import translationsEN from './locales/en/common.json'
import iconFlagUS from '../images/flags/us.svg'
// ES
import translationsES from './locales/es/common.json'
import iconFlagES from '../images/flags/es.svg'
// PT
import translationsPT from './locales/pt/common.json'
import iconFlagPT from '../images/flags/pt.svg'
// FR
import translationsFR from './locales/fr/common.json'
import iconFlagFR from '../images/flags/fr.svg'
// RU
import translationsRU from './locales/ru/common.json'
import iconFlagRU from '../images/flags/ru.svg'
// IT
import iconFlagIT from '../images/flags/it.svg'
// DE
import translationsDE from './locales/de/common.json'
import iconFlagDE from '../images/flags/de.svg'
// PL
import iconFlagPL from '../images/flags/pl.svg'
// CN
import iconFlagCN from '../images/flags/cn.svg'

export const LOCALES = {
    EN: 'en',
    ES: 'es',
    FR: 'fr',
    IT: 'it',
    PL: 'pl',
    RU: 'ru',
    ZH: 'zh',
    PT: 'pt',
    DE: 'de',
}

const LOCALES_DETAILS = [
    {
        code: LOCALES.EN,
        fullCode: 'en_US',
        deeplCode: 'en-us',
        isDeeplRequired: true,
        label: 'English',
        translations: translationsEN,
        icon: iconFlagUS,
        is_enabled: true,
        is_visible: true,
    },
    {
        code: LOCALES.ES,
        fullCode: 'es_ES',
        deeplCode: 'es',
        isDeeplRequired: true,
        label: 'Español',
        translations: translationsES,
        icon: iconFlagES,
        is_enabled: true,
        is_visible: true,
    },
    {
        code: LOCALES.PT,
        fullCode: 'pt_PT',
        deeplCode: 'pt-pt',
        isDeeplRequired: true,
        label: 'Português',
        translations: translationsPT,
        icon: iconFlagPT,
        is_enabled: true,
        is_visible: true,
    },
    {
        code: LOCALES.FR,
        fullCode: 'fr_FR',
        deeplCode: 'fr',
        isDeeplRequired: true,
        label: 'Français',
        translations: translationsFR,
        icon: iconFlagFR,
        is_enabled: true,
        is_visible: true,
    },
    {
        code: LOCALES.RU,
        fullCode: 'ru_RU',
        deeplCode: 'ru',
        isDeeplRequired: true,
        label: 'Русский',
        translations: translationsRU,
        icon: iconFlagRU,
        is_enabled: true,
        is_visible: true,
    },
    {
        code: LOCALES.DE,
        fullCode: 'de_DE',
        deeplCode: 'de',
        isDeeplRequired: true,
        label: 'Deutsch',
        translations: translationsDE,
        icon: iconFlagDE,
        is_enabled: true,
        is_visible: true,
    },
    {
        code: LOCALES.IT,
        fullCode: 'it_IT',
        deeplCode: 'it',
        isDeeplRequired: false,
        label: 'Italiano',
        translations: null,
        icon: iconFlagIT,
        is_enabled: false,
        is_visible: true,
    },
    {
        code: LOCALES.PL,
        fullCode: 'pl_PL',
        deeplCode: 'pl',
        isDeeplRequired: false,
        label: 'Polski',
        translations: null,
        icon: iconFlagPL,
        is_enabled: false,
        is_visible: true,
    },
    {
        code: LOCALES.ZH,
        fullCode: 'zh_CN',
        deeplCode: 'zh',
        isDeeplRequired: false,
        label: '中国',
        translations: null,
        icon: iconFlagCN,
        is_enabled: false,
        is_visible: true,
    },
]

export const DEFAULT_LOCALE = LOCALES.EN
export const BASE_LOCALE = LOCALES.RU

export const LOCALES_PATH = 'packages/interacty-client/src/i18n/locales'

export default LOCALES_DETAILS

export const SUPPORTED_LOCALES_DETAILS = LOCALES_DETAILS.filter(locale => locale.is_enabled)

export const findLanguageByCode = code => LOCALES_DETAILS.find(lng => lng.code === code)
